import React from 'react';
export function Footer() {
  return <footer className="bg-neutral-900 border-t-4 border-red-700 py-10 px-4 text-center" data-id="element-122" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/80" data-id="element-123" data-mp="3ggtymjf7hl5r">
        © Fire Service Instructor Atlas 2026 — All Rights Reserved.
      </p>
    </footer>;
}